import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard, FileText, Sun, Container, Users, FolderKanban,
  BookOpen, PanelsTopLeft, Package, UserCog, BarChart3, GitCompareArrows, Settings2,
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const SECTIONS = [
  {
    title: 'Principal',
    items: [{ to: '/', label: 'Dashboard', icon: LayoutDashboard, testid: 'sidebar-nav-dashboard', end: true }],
  },
  {
    title: 'Cotizaciones',
    items: [
      { to: '/cotizaciones', label: 'Cotizaciones Prefab', icon: FileText, testid: 'sidebar-nav-cotizaciones-prefab' },
      { to: '/cotizaciones-pv', label: 'eHenergia / Prefab PV', icon: Sun, testid: 'sidebar-nav-cotizaciones-pv' },
      { to: '/contenedores', label: 'Contenedores', icon: Container, testid: 'sidebar-nav-contenedores' },
    ],
  },
  {
    title: 'Datos',
    items: [
      { to: '/clientes', label: 'Clientes', icon: Users, testid: 'sidebar-nav-clientes' },
      { to: '/proyectos', label: 'Proyectos', icon: FolderKanban, testid: 'sidebar-nav-proyectos' },
    ],
  },
  {
    title: 'Análisis',
    items: [
      { to: '/reportes', label: 'Reportes', icon: BarChart3, testid: 'sidebar-nav-reportes' },
      { to: '/comparador', label: 'Comparador', icon: GitCompareArrows, testid: 'sidebar-nav-comparador' },
    ],
  },
  {
    title: 'Catálogos',
    items: [
      { to: '/catalogo', label: 'Catálogo Prefab', icon: BookOpen, testid: 'sidebar-nav-catalogo-prefab' },
      { to: '/catalogo-pv', label: 'Catálogo PV', icon: PanelsTopLeft, testid: 'sidebar-nav-catalogo-pv' },
      { to: '/catalogo-contenedores', label: 'Catálogo Contenedores', icon: Package, testid: 'sidebar-nav-catalogo-contenedores' },
    ],
  },
];

export const Sidebar = () => {
  const { canManageUsers } = useAuth();
  const adminItems = [
    { to: '/configuracion', label: 'Configuración', icon: Settings2, testid: 'sidebar-nav-configuracion' },
    ...(canManageUsers ? [{ to: '/usuarios', label: 'Usuarios', icon: UserCog, testid: 'sidebar-nav-usuarios' }] : []),
  ];
  const sections = [...SECTIONS, { title: 'Administración', items: adminItems }];

  return (
    <aside
      data-testid="app-sidebar"
      className="hidden md:flex flex-col fixed inset-y-0 left-0 w-[260px] border-r border-border bg-card/40 z-30"
    >
      <div className="h-14 flex items-center gap-2.5 px-5 border-b border-border">
        <img src="/assets/logo.png" alt="Logotipo" className="h-9 w-auto" data-testid="sidebar-logo" />
        <div className="leading-tight">
          <div className="font-semibold text-[15px]" style={{ fontFamily: 'Space Grotesk' }}>CotizaBuilder</div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">APU · México</div>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto py-4 scrollbar-thin">
        {sections.map((section) => (
          <div key={section.title} className="mb-4">
            <div className="px-5 mb-1.5 text-[10px] uppercase tracking-widest text-muted-foreground/70 font-medium">
              {section.title}
            </div>
            {section.items.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  data-testid={item.testid}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-5 py-2 text-[13px] border-l-2 transition-colors duration-150 ${
                      isActive
                        ? 'bg-primary/10 border-primary text-foreground font-medium'
                        : 'border-transparent text-muted-foreground hover:bg-card/60 hover:text-foreground'
                    }`
                  }
                >
                  <Icon size={17} strokeWidth={1.75} />
                  {item.label}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>
      <div className="px-5 py-3 border-t border-border text-[11px] text-muted-foreground">
        PREFABCON · v2.0
      </div>
    </aside>
  );
};
